import React, { useState } from "react";
import { ExternalLink as ExtIcon, ShieldAlert, X, Lock } from "lucide-react";
import { isProtonDrive } from "../lib/proton";

// A creator's external website link. Because leaving Sovereign Signal means
// leaving our encrypted space, we always show a clear "you're leaving"
// confirmation before opening the destination, in a new tab, with no referrer.
export const ExternalLinkButton = ({ url, label, thumbNode, accent = "#14A89A", testid, className }) => {
  const [confirm, setConfirm] = useState(false);
  if (!url) return null;
  let host = url;
  try { host = new URL(url).hostname.replace(/^www\./, ""); } catch { /* keep raw */ }
  const go = () => { window.open(url, "_blank", "noopener,noreferrer"); setConfirm(false); };
  return (
    <>
      <button
        onClick={() => setConfirm(true)}
        data-testid={testid || "beacon-external-link"}
        className={className || "inline-flex items-center gap-2 border px-3 py-2 font-body text-sm mt-2 hover:brightness-110 transition"}
        style={{ borderColor: accent, color: accent }}
      >
        {thumbNode ? <span className="w-5 h-5 rounded overflow-hidden shrink-0 flex items-center justify-center">{thumbNode}</span> : <ExtIcon size={14} />}
        <span className="truncate max-w-[240px]">{label || host}</span>
      </button>
      {isProtonDrive(url) && <span className="mt-1 flex items-center gap-1 font-body text-[11px] text-zinc-400" data-testid={`${testid || "beacon-external-link"}-drive-label`}><Lock size={11} className="text-[#14A89A]" /> Opens in Proton Drive, encrypted</span>}
      {confirm && (
        <div className="fixed inset-0 z-[100] bg-black/70 backdrop-blur-sm flex items-center justify-center p-4" onClick={() => setConfirm(false)} data-testid="external-link-confirm">
          <div onClick={(e) => e.stopPropagation()} className="bg-[#121212] border border-white/10 max-w-md w-full p-6 relative">
            <button onClick={() => setConfirm(false)} className="absolute top-3 right-3 text-zinc-500 hover:text-white" data-testid="external-link-close"><X size={18} /></button>
            <div className="flex items-center gap-2 mb-3" style={{ color: accent }}><ShieldAlert size={20} /><h3 className="font-heading text-lg text-white">You're leaving Sovereign Signal</h3></div>
            <p className="font-body text-sm text-zinc-300 leading-relaxed mb-1">This opens an external website in a new tab:</p>
            <p className="font-body text-sm text-white break-all mb-4">{url}</p>
            <p className="font-body text-xs text-zinc-500 leading-relaxed mb-5">Outside Sovereign Signal your privacy is no longer protected by our encryption. We open the link with no referrer, but the destination site is beyond our walls, continue only if you trust it.</p>
            <div className="flex justify-end gap-2">
              <button onClick={() => setConfirm(false)} className="border border-white/15 text-zinc-300 px-4 py-2 font-body text-sm hover:bg-white/5" data-testid="external-link-stay">Stay</button>
              <button onClick={go} data-testid="external-link-continue" className="font-semibold px-5 py-2 font-body text-sm" style={{ background: accent, color: "#0A0A0A" }}>Continue</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
